/**
 * Conditionally adds meta viewport tag in order to avoid zooming on ios when selecting form field and allow user zooming on ios and android
 */
export default {
  id: 'molten.SetMetaViewport',
  sort: -100,
  init: async () => {
    addMaximumScaleToMetaViewport();
  }
};

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
const checkIsIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
function addMaximumScaleToMetaViewport() {
  if (!checkIsIOS()) {
    return;
  }
  let el = document.querySelector('meta[name=viewport]');
  if (el == null) {
    el = document.createElement('meta');
    document.querySelector('head').appendChild(el);
  }
  if (el !== null) {
    let content = el.getAttribute('content');
    const re = /maximum-scale=[0-9.]+/g;
    if (re.test(content)) {
      content = content.replace(re, 'maximum-scale=1.0');
    } else {
      content = [content, 'maximum-scale=1.0'].join(', ');
    }
    el.setAttribute('content', content);
  }
}